import AppSettings from "../AppSettings";
import gaskets from "./gasket/GasketInfo.json";
import { parseFraction } from "./gasket/dimensions";

function isGasket(part) {
  if (!part || !part.attributes) return false;
  return part.attributes.some(attr => attr.name === "Unit" && attr.value === "Pre-Molded");
}

function getGasket(partId) {
  partId = partId ? partId.toUpperCase(partId) : "";
  const gasket = gaskets.find(part => part.partId === partId);
  return gasket;
}

function customPartType(part) {
  if (part.custom) return part.custom;

  if (isGasket(part)) return "Gasket";
  return "";
}

function isCustomPart(part) {
  return !!customPartType(part);
}

function hasCustomParts(parts) {
  return parts.filter(part => isCustomPart(part)).length > 0;
}

function profileUrl(gasket) {
  return `${AppSettings.ImageService}/catalog/graphics%2fDrawings%5c${gasket.profile}.png`;
}

function gasketPrice(partId, heightString, widthString, discountLevel) {
  console.log("DiscountLevel in GasketPrice", discountLevel)
  const standardPrice = [
    [44, 27, 22], // extra small
    [56, 35, 28], // small
    [66, 41, 35], // medium
    [75, 48, 41], // large
    [85, 59, 48] // extra large
  ];
  const price_MG064S = [
    [51, 34, 29], // extra small
    [67, 45, 39], // small
    [80, 55, 48], // medium
    [92, 65, 60], // large
    [108, 75, 69] // extra large
  ];
  const price_0214160 = [
    [70, 39, 34], // extra small
    [90, 50, 44], // small
    [106, 60, 53], // medium
    [120, 69, 64], // large
    [136, 85, 75] // extra large
  ];

  const priceLevelIndex = discountLevel === "Wholesale" ? 2 : discountLevel === "Dealer" ? 1 : 0;
  const parsedHeight = parseFraction(heightString);
  const parsedWidth = parseFraction(widthString);
  if (!parsedHeight || !parsedWidth) {
    return null;
  }
  const height = parsedHeight;
  const width = parsedWidth;
  const size = height > width ? height : width;
  const sizeIndex = size < 31 ? 0 : size < 51 ? 1 : size < 71 ? 2 : size < 81 ? 3 : 4;
  const priceTable = partId === "MG064S" ? price_MG064S : partId === "02-14160" ? price_0214160 : standardPrice;
  const price = priceTable[sizeIndex][priceLevelIndex];
  
  return price;
}

export { isGasket, getGasket, customPartType, isCustomPart, hasCustomParts, profileUrl, gasketPrice };
